import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Loader, SectionHeading } from "../../../components";
import { selectUploadProgress } from "../../../../store";

export const Upload = () => {
  const { t } = useTranslation();

  const progress = useSelector(selectUploadProgress)

  return (
    <>
      <SectionHeading
        title={t("upload.uploading.title")}
        subtitle={t("upload.uploading.subtitle")}
      />
      <Loader progress={progress} label={t("upload.uploading.progress")}/>

        {/* STOP UPLOAD BUTTON currently hidden */}
        {/* <Button
          variant="error"
          appearance="link"
          icon={<IconCancel />}
          onClick={() => dispatch(stopUpload())}
        >
          {t("upload.footer.stopBtn")}
        </Button> */}

    </>
  )
}